import { CSSProperties } from "react";
import { EmbedLegacyProps } from "../content-blocks/EmbedLegacy.component";

declare global {
    interface Window {
        FB: { XFBML: { parse?: () => void }; init: (opts: any) => void };
        twttr: { widgets: { load: () => void } };
        instgrm: { Embeds: { process: () => void } };
    }
}

export function activateEmbeds(div: HTMLDivElement) {
    div.querySelectorAll(".component-embed-script").forEach(placeholder => {
        if (!placeholder.classList.contains("activated") && placeholder instanceof HTMLDivElement) {
            const script = document.createElement("script");
            script.setAttribute("src", placeholder.dataset.src || "");
            script.setAttribute("async", "true");
            placeholder.appendChild(script);
            placeholder.classList.add("activated");
        }
    });
}

export const attributeDimensionToInt = (attr: string | number | null | undefined) => {
    if (typeof attr === "number") {
        return attr;
    } else if (typeof attr === "string" && !attr.includes("%")) {
        // if string is only number or is px value, use parseInt (IHRAL-6431)
        if (/^\d+$/i.test(attr) || attr.includes("px")) {
            return parseInt(attr, 10);
        }
    }
    return 0;
};

export const getResponsiveStyles = (width: string, height: string) => {
    const styles: CSSProperties = {};
    const reg = RegExp("%", "i");
    const modifier = 1.1;

    if (width && height) {
        const intWidth = attributeDimensionToInt(width);
        const intHeight = attributeDimensionToInt(height);
        const percentageWidth = reg.test(width);
        const percentageHeight = reg.test(height);
        if (percentageWidth && !percentageHeight) {
            styles.paddingBottom = `${intHeight * modifier}px`;
        } else if (!percentageWidth && percentageHeight) {
            styles.paddingBottom = `${intHeight * modifier}%`;
        } else {
            const aspect_ratio = (intHeight / intWidth) * 100 * modifier;
            styles.paddingBottom = `${aspect_ratio}%`;
        }
    }
    return styles;
};

export interface GenericEmbedDetails {
    embed_type: string;
    provider: string;
    url: string | undefined;
}

export const getGenericEmbed = (props: EmbedLegacyProps) => {
    const details: GenericEmbedDetails = {
        embed_type: props.embed_type,
        provider: props.provider || "",
        url: props.url,
    };
    if (!props.url) {
        return details;
    }
    try {
        const url = new URL(props.url);
        if (url.hostname.includes("facebook.com")) {
            details.provider = "facebook";
            if (url.pathname.includes("video.php")) {
                details.embed_type = "video";
                const href = url.searchParams.get("href");
                if (href) {
                    details.url = href;
                }
            }
        } else if (url.hostname.includes("youtube.com")) {
            details.provider = "youtube";
            details.embed_type = "video";
        }

        return details;
    } catch (err) {
        return details;
    }
};

export const vendorRefreshFns: any = {
    Facebook: () => window.FB && window.FB.XFBML.parse && window.FB.XFBML.parse(),
    Twitter: () => window.twttr && window.twttr.widgets.load(),
    Instagram: () => window.instgrm && window.instgrm.Embeds.process(),
};
